export const MAP_SETTINGS_FILTERING_CHANGE_DATA_TYPE = 'MAP_SETTINGS_FILTERING/CHANGE_DATA_TYPE';

export const MAP_SETTINGS_FILTERING_TOGGLE_ON_OFF = 'MAP_SETTINGS_FILTERING/TOGGLE_ON_OFF';
export const MAP_SETTINGS_FILTERING_TURN_FILTER_ON = 'MAP_SETTINGS_FILTERING/TURN_FILTER_ON';

export const MAP_SETTINGS_FILTERING_SET_SETTINGS = 'MAP_SETTINGS_FILTERING/SET_SETTINGS';
